// URL contract for a checkout without the product picker: the product page
// picker passes identifiers only, and checkout resolves prices from its pack.
export const PRESELECTION_PARAMS = {
  amount: "qty",
  subscribe: "sub",
};

export const readPreselection = (search) => {
  const params = new URLSearchParams(search);
  const rawAmount = params.get(PRESELECTION_PARAMS.amount);
  const rawSubscribe = params.get(PRESELECTION_PARAMS.subscribe);
  const amount = /^\d+$/.test(rawAmount ?? "") ? Number(rawAmount) : null;

  let subscribe = null;
  if (rawSubscribe === "1") subscribe = true;
  if (rawSubscribe === "0") subscribe = false;

  return { amount: amount > 0 ? amount : null, subscribe };
};

// Picks the pack product and purchase type for a preselection. An unknown
// amount falls back to the best seller (or the first product). Subscription
// needs an explicit `sub=1`, and applies only when the pack enables it and has
// a product for that amount; anything else is a one-time purchase.
export const resolvePreselection = (products, subscription, { amount = null, subscribe = null } = {}) => {
  if (!Array.isArray(products) || products.length === 0) return null;

  const requested = amount !== null ? products.find((p) => Number(p.amount) === amount) : undefined;
  const product = requested ?? products.find((p) => p.best_seller === true) ?? products[0];

  const subscriptionEnabled = !!subscription?.subscription_enable;
  const hasSubscriptionProduct =
    Array.isArray(subscription?.products) && subscription.products.some((sp) => sp.amount === product.amount);

  return {
    amount: product.amount,
    isSubscribe: subscribe === true && subscriptionEnabled && hasSubscriptionProduct,
  };
};
